import { useTranslation } from "react-i18next";
import { memo } from "react";
import { Link } from "react-router-dom";
import MediaPartner from "./MediaPartner";
import "./Footer.css";

const Footer = memo(function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/about">{t("footer.about")}</Link>
          <Link to="/contact">{t("footer.contact")}</Link>
        </div>
        <p className="copyright">
          {t("footer.copyright", { year: currentYear })}
        </p>
        <p className="footer-powered-by">{t("footer.poweredBy")}</p>
        <MediaPartner variant="footer" />
        <p className="footer-disclaimer">{t("footer.disclaimer")}</p>
      </div>
    </footer>
  );
});

export default Footer;
